import { FlexGrid, FlexGridItem } from "baseui/flex-grid";
import RenderIfVisible from "react-render-if-visible";
import { useMediaQuery } from "../../../hooks";
import React from "react";


export function FlexGridView(props: { children: any, flexGridColumnCount?: any }) {
    const isHighRatio = useMediaQuery("only screen and (-webkit-min-device-pixel-ratio: 1.5)");
    const columnCount = props.flexGridColumnCount ? props.flexGridColumnCount : isHighRatio ? [1, 1, 2, 3] : [1, 1, 2, 4];
    return (
        <FlexGrid
            flexGridColumnCount={columnCount}
            flexGridColumnGap="scale800"
            flexGridRowGap="scale800"
        >
            {React.Children.map(props.children, (child) => {
                if (React.isValidElement(child)) {
                    // set the map prop on the child component
                    // @ts-ignore
                    return (
                        <FlexGridItem >
                            <RenderIfVisible defaultHeight={600} visibleOffset={100} stayRendered>
                                {React.cloneElement(child)}
                            </RenderIfVisible>
                        </FlexGridItem>
                    )
                }
            })}
        </FlexGrid>
    )
}